import styled from 'styled-components'

export const Radio = styled.label`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 0;
    position: relative;
    font-size: 0.875rem !important;
    cursor: pointer;
    font-weight: 300 !important;

    &:hover {
        .radio {
            border-color: ${props => props.theme.admin.colors.brand};
        }
    }

    input {
        width: auto;
        margin-right: 15px;
        opacity: 0;
        visibility: hidden;
        height: 30px;
    }

    .radio {
        position: absolute;
        top: calc(50% - 10px);
        left: 0;

        display: inline-block;
        height: 19px;
        width: 19px;
        border-radius: 50%;
        border: 1px solid ${props => props.theme.admin.font.color};
        transition: border 0.2s linear;
    }

    input:checked + .radio {
        &:before {
            content: '';
            display: block;
            height: 11px;
            width: 11px;
            border-radius: 50%;
            position: absolute;
            top: 3px;
            left: 3px;
            background-color: ${props => props.theme.admin.colors.brand};
        }
    }
`
